// Centralized vehicle data with CS/EN/DE localization.
// Localizable fields are objects { cs, en, de }; use localize(field, lang).
// Add a new object here to publish a new car.

export const VEHICLES = [
  {
    slug: "hyundai-tucson-2025",
    name: "Hyundai Tucson",
    year: 2025,
    bodyType: { cs: "SUV", en: "SUV", de: "SUV" },
    priceMonthly: 17500,
    fuel: { cs: "Benzín i hybrid", en: "Petrol & hybrid", de: "Benzin & Hybrid" },
    transmission: { cs: "Automat", en: "Automatic", de: "Automatik" },
    mileage: { cs: "cca 14 000 km", en: "approx. 14,000 km", de: "ca. 14.000 km" },
    multipleAvailable: true,
    images: [
      { url: "/img/pb0cgwpr_T8.webp", alt: "Hyundai Tucson 2025 zepředu", label: "Zepředu" },
      { url: "/img/i5vs4l6g_T3.webp", alt: "Hyundai Tucson 2025 z boku", label: "Bok" },
      { url: "/img/69j497uu_8.webp", alt: "Hyundai Tucson 2025 interiér", label: "Interiér" },
      { url: "/img/vua9m3c9_T6.webp", alt: "Hyundai Tucson 2025 zezadu", label: "Zezadu" },
      { url: "/img/hfb6kune_T4.webp", alt: "Hyundai Tucson 2025 zavazadlový prostor", label: "Kufr" },
    ],
    featureGroups: [
      {
        title: { cs: "Komfort a interiér", en: "Comfort and interior", de: "Komfort und Innenraum" },
        items: [
          { cs: "Dvouzónová automatická klimatizace", en: "Dual-zone automatic climate control", de: "Zwei-Zonen-Klimaautomatik" },
          { cs: "Vyhřívaná přední sedadla", en: "Heated front seats", de: "Beheizte Vordersitze" },
          { cs: "Vyhřívaný kožený volant", en: "Heated leather steering wheel", de: "Beheiztes Lederlenkrad" },
          { cs: "Bezklíčové odemykání a startování (Smart Key)", en: "Keyless entry and start (Smart Key)", de: "Schlüsselloses Öffnen und Starten (Smart Key)" },
          { cs: "Akustická skla pro maximálně tichou jízdu", en: "Acoustic glass for an extra quiet ride", de: "Akustikverglasung für maximal leise Fahrt" },
        ],
      },
      {
        title: { cs: "Moderní technologie a multimédia", en: "Modern technology and multimedia", de: "Moderne Technik und Multimedia" },
        items: [
          { cs: '12,3" integrovaná dotyková navigace', en: '12.3" integrated touchscreen navigation', de: '12,3" integrierte Touchscreen-Navigation' },
          { cs: '12,3" digitální přístrojový panel', en: '12.3" digital instrument cluster', de: '12,3" digitales Kombiinstrument' },
          { cs: "Bezdrátové Apple CarPlay a Android Auto", en: "Wireless Apple CarPlay and Android Auto", de: "Kabelloses Apple CarPlay und Android Auto" },
          { cs: "Bezdrátové nabíjení telefonu", en: "Wireless phone charging", de: "Kabelloses Laden des Smartphones" },
        ],
      },
      {
        title: { cs: "Bezpečnostní a asistenční systémy", en: "Safety and assistance systems", de: "Sicherheits- und Assistenzsysteme" },
        items: [
          { cs: "Zadní parkovací kamera", en: "Rear parking camera", de: "Rückfahrkamera" },
          { cs: "Přední a zadní parkovací senzory", en: "Front and rear parking sensors", de: "Parksensoren vorne und hinten" },
          { cs: "Hlídání mrtvého úhlu", en: "Blind-spot monitoring", de: "Totwinkel-Assistent" },
          { cs: "Aktivní udržování vozu v jízdním pruhu", en: "Active lane keeping assist", de: "Aktiver Spurhalteassistent" },
          { cs: "Autonomní nouzové brzdění", en: "Autonomous emergency braking", de: "Autonomes Notbremssystem" },
        ],
      },
      {
        title: { cs: "Exteriér", en: "Exterior", de: "Exterieur" },
        items: [
          { cs: "Bi-LED přední světlomety", en: "Bi-LED headlights", de: "Bi-LED-Scheinwerfer" },
          { cs: '17" originální alu kola', en: '17" original alloy wheels', de: '17" Original-Leichtmetallräder' },
          { cs: "Zatmavená zadní skla", en: "Tinted rear windows", de: "Abgedunkelte hintere Scheiben" },
        ],
      },
    ],
  },

  {
    slug: "skoda-kodiaq-lk-2023",
    name: "Škoda Kodiaq Laurin & Klement",
    year: 2023,
    bodyType: { cs: "SUV", en: "SUV", de: "SUV" },
    priceMonthly: 23000,
    fuel: { cs: "Nafta 2.0 TDI 147 kW", en: "Diesel 2.0 TDI 147 kW", de: "Diesel 2.0 TDI 147 kW" },
    transmission: { cs: "Automat (DSG)", en: "Automatic (DSG)", de: "Automatik (DSG)" },
    mileage: null,
    multipleAvailable: true,
    description: {
      cs: "Vrcholná, luxusní verze první generace Kodiaqu před příchodem nové generace.",
      en: "The top-of-the-range luxury version of the first-generation Kodiaq before the arrival of the new generation.",
      de: "Die luxuriöse Top-Version des Kodiaq der ersten Generation vor dem Erscheinen der neuen Generation.",
    },
    images: [
      { url: "/img/3p72u9i9_K1.webp", alt: "Škoda Kodiaq L&K zepředu", label: "Zepředu" },
      { url: "/img/jl6r5erh_K2.webp", alt: "Škoda Kodiaq L&K přední profil", label: "Přední profil" },
      { url: "/img/ckd7hcep_IMG_6912.webp", alt: "Škoda Kodiaq L&K zezadu", label: "Zezadu" },
      { url: "/img/msauw45h_K3.webp", alt: "Škoda Kodiaq L&K interiér", label: "Interiér" },
    ],
    featureGroups: [
      {
        title: { cs: "Komfort a interiér", en: "Comfort and interior", de: "Komfort und Innenraum" },
        items: [
          { cs: "Třízónová automatická klimatizace Climatronic", en: "Three-zone Climatronic automatic climate control", de: "Drei-Zonen-Klimaautomatik Climatronic" },
          { cs: "Exkluzivní kožená sedadla s logem L&K", en: "Exclusive leather seats with L&K logo", de: "Exklusive Ledersitze mit L&K-Logo" },
          { cs: "Elektricky nastavitelná přední sedadla s pamětí, vyhříváním a odvětráváním", en: "Electrically adjustable front seats with memory, heating and ventilation", de: "Elektrisch verstellbare Vordersitze mit Memory, Heizung und Belüftung" },
          { cs: "Vyhřívaný multifunkční kožený volant s pádly pro řazení", en: "Heated multifunction leather steering wheel with shift paddles", de: "Beheiztes Multifunktions-Lederlenkrad mit Schaltwippen" },
          { cs: "Ambientní LED osvětlení interiéru", en: "Ambient LED interior lighting", de: "Ambiente-LED-Innenbeleuchtung" },
        ],
      },
      {
        title: { cs: "Moderní technologie a multimédia", en: "Modern technology and multimedia", de: "Moderne Technik und Multimedia" },
        items: [
          { cs: 'Virtuální kokpit 10,25" (digitální budíky)', en: '10.25" virtual cockpit (digital dials)', de: '10,25" Virtual Cockpit (digitale Anzeigen)' },
          { cs: "Špičkový infotainment Columbus s navigací a velkým dotykovým displejem", en: "Top Columbus infotainment with navigation and a large touchscreen", de: "Hochwertiges Columbus-Infotainment mit Navigation und großem Touchscreen" },
          { cs: "Prémiový audiosystém CANTON", en: "Premium CANTON audio system", de: "Premium-Soundsystem CANTON" },
          { cs: "Bezdrátový SmartLink (Apple CarPlay a Android Auto) + bezdrátové nabíjení telefonu", en: "Wireless SmartLink (Apple CarPlay and Android Auto) + wireless phone charging", de: "Kabelloses SmartLink (Apple CarPlay und Android Auto) + kabelloses Laden" },
        ],
      },
      {
        title: { cs: "Bezpečnostní a asistenční systémy", en: "Safety and assistance systems", de: "Sicherheits- und Assistenzsysteme" },
        items: [
          { cs: "Adaptivní podvozek s volbou jízdních režimů", en: "Adaptive chassis with driving mode selection", de: "Adaptives Fahrwerk mit Fahrmoduswahl" },
          { cs: "360° kamerový systém (Area View) + přední a zadní parkovací senzory", en: "360° camera system (Area View) + front and rear parking sensors", de: "360°-Kamerasystem (Area View) + Parksensoren vorne und hinten" },
          { cs: "Adaptivní tempomat", en: "Adaptive cruise control", de: "Adaptiver Tempomat" },
          { cs: "Asistent hlídání jízdního pruhu", en: "Lane keeping assist", de: "Spurhalteassistent" },
          { cs: "Hlídání mrtvého úhlu a asistent vyparkování", en: "Blind-spot monitoring and exit assistant", de: "Totwinkel-Assistent und Ausparkassistent" },
          { cs: "KESSY – bezklíčové odemykání, zamykání a startování", en: "KESSY – keyless entry, locking and start", de: "KESSY – schlüsselloses Öffnen, Verriegeln und Starten" },
        ],
      },
      {
        title: { cs: "Exteriér", en: "Exterior", de: "Exterieur" },
        items: [
          { cs: "Matrix-LED přední světlomety s dálkovým asistentem", en: "Matrix LED headlights with high-beam assistant", de: "Matrix-LED-Scheinwerfer mit Fernlichtassistent" },
          { cs: '20" specifická alu kola', en: '20" specific alloy wheels', de: '20" spezifische Leichtmetallräder' },
          { cs: "Elektrické víko zavazadlového prostoru + možnost otevření nohou", en: "Electric tailgate + hands-free (foot) opening", de: "Elektrische Heckklappe + Öffnen mit dem Fuß" },
          { cs: "Chromová maska chladiče, lišty kolem oken a střešní nosiče", en: "Chrome radiator grille, window trims and roof rails", de: "Chrom-Kühlergrill, Fensterleisten und Dachreling" },
        ],
      },
    ],
  },

  {
    slug: "hyundai-i30-kombi",
    name: "Hyundai i30 Kombi",
    year: 2025,
    bodyType: { cs: "Kombi", en: "Estate", de: "Kombi" },
    priceMonthly: 14500,
    fuel: { cs: "Benzín", en: "Petrol", de: "Benzin" },
    transmission: { cs: "Automat", en: "Automatic", de: "Automatik" },
    mileage: { cs: "cca 5 000 km", en: "approx. 5,000 km", de: "ca. 5.000 km" },
    multipleAvailable: true,
    description: {
      cs: "K dispozici v několika barevných provedeních.",
      en: "Available in several color variants.",
      de: "In mehreren Farbvarianten verfügbar.",
    },
    images: [
      { url: "/img/er1feys6_i30_5.webp", alt: "Hyundai i30 Kombi zepředu", label: "Zepředu" },
      { url: "/img/bioptyly_i30_2.webp", alt: "Hyundai i30 Kombi přední profil", label: "Přední profil" },
      { url: "/img/c9hd4h1o_i30_1.webp", alt: "Hyundai i30 Kombi zezadu", label: "Zezadu" },
      { url: "/img/ghk9p2lu_i30_3.webp", alt: "Hyundai i30 Kombi multimédia a parkovací systém", label: "Multimédia" },
      { url: "/img/7h0unbp4_i30_4.webp", alt: "Hyundai i30 Kombi zavazadlový prostor", label: "Kufr" },
    ],
    featureGroups: [
      {
        title: { cs: "Komfort a interiér", en: "Comfort and interior", de: "Komfort und Innenraum" },
        items: [
          { cs: "Dvouzónová automatická klimatizace", en: "Dual-zone automatic climate control", de: "Zwei-Zonen-Klimaautomatik" },
          { cs: "Vyhřívaná přední sedadla", en: "Heated front seats", de: "Beheizte Vordersitze" },
          { cs: "Vyhřívaný kožený volant", en: "Heated leather steering wheel", de: "Beheiztes Lederlenkrad" },
          { cs: "Elektrická bederní opěrka pro řidiče", en: "Electric lumbar support for the driver", de: "Elektrische Lordosenstütze für den Fahrer" },
          { cs: "Přední loketní opěrka", en: "Front armrest", de: "Vordere Armlehne" },
        ],
      },
      {
        title: { cs: "Moderní technologie a multimédia", en: "Modern technology and multimedia", de: "Moderne Technik und Multimedia" },
        items: [
          { cs: '10,25" integrovaná dotyková navigace', en: '10.25" integrated touchscreen navigation', de: '10,25" integrierte Touchscreen-Navigation' },
          { cs: 'Plně digitální 10,25" přístrojový panel (se 4 režimy zobrazení)', en: 'Fully digital 10.25" instrument cluster (with 4 display modes)', de: 'Voll digitales 10,25" Kombiinstrument (mit 4 Anzeigemodi)' },
          { cs: "Vzdálená správa vozu Bluelink", en: "Bluelink remote vehicle management", de: "Bluelink Fernsteuerung des Fahrzeugs" },
          { cs: "Apple CarPlay a Android Auto", en: "Apple CarPlay and Android Auto", de: "Apple CarPlay und Android Auto" },
          { cs: "Volič jízdních režimů Drive Mode", en: "Drive Mode selector", de: "Fahrmoduswahl Drive Mode" },
          { cs: "Bluetooth handsfree", en: "Bluetooth hands-free", de: "Bluetooth-Freisprecheinrichtung" },
          { cs: "USB-C konektory pro dobíjení vzadu", en: "USB-C charging ports in the rear", de: "USB-C-Anschlüsse zum Laden hinten" },
        ],
      },
      {
        title: { cs: "Bezpečnostní a asistenční systémy", en: "Safety and assistance systems", de: "Sicherheits- und Assistenzsysteme" },
        items: [
          { cs: "Zadní parkovací kamera", en: "Rear parking camera", de: "Rückfahrkamera" },
          { cs: "Přední a zadní parkovací senzory", en: "Front and rear parking sensors", de: "Parksensoren vorne und hinten" },
          { cs: "Aktivní asistent pro vedení vozu uprostřed jízdního pruhu", en: "Active lane following assist", de: "Aktiver Spurführungsassistent" },
          { cs: "Automatické nouzové brzdění s detekcí aut, chodců a cyklistů", en: "Automatic emergency braking with car, pedestrian and cyclist detection", de: "Automatisches Notbremssystem mit Fahrzeug-, Fußgänger- und Radfahrererkennung" },
          { cs: "Upozornění na cestující vzadu", en: "Rear seat occupant alert", de: "Hinweis auf Insassen im Fond" },
        ],
      },
      {
        title: { cs: "Exteriér", en: "Exterior", de: "Exterieur" },
        items: [
          { cs: "Bi-LED přední světlomety s přisvěcováním do zatáčky", en: "Bi-LED headlights with cornering light", de: "Bi-LED-Scheinwerfer mit Abbiegelicht" },
          { cs: '16" originální kola z lehké slitiny', en: '16" original alloy wheels', de: '16" Original-Leichtmetallräder' },
          { cs: "Zatmavená zadní skla", en: "Tinted rear windows", de: "Abgedunkelte hintere Scheiben" },
          { cs: "Elektricky nastavitelná vyhřívaná zrcátka", en: "Electrically adjustable, heated mirrors", de: "Elektrisch verstellbare, beheizbare Spiegel" },
        ],
      },
    ],
  },

  {
    slug: "hyundai-i20-2025",
    name: "Hyundai i20",
    year: 2025,
    bodyType: { cs: "Hatchback", en: "Hatchback", de: "Schrägheck" },
    priceMonthly: 12000,
    fuel: { cs: "Benzín", en: "Petrol", de: "Benzin" },
    transmission: { cs: "Automat", en: "Automatic", de: "Automatik" },
    mileage: { cs: "cca 7 000 km", en: "approx. 7,000 km", de: "ca. 7.000 km" },
    multipleAvailable: true,
    images: [
      { url: "/img/ejtrflxy_IMG_6915.webp", alt: "Hyundai i20 2025 zepředu", label: "Zepředu" },
      { url: "/img/e4alstvz_i20_2.webp", alt: "Hyundai i20 2025 z boku", label: "Bok" },
      { url: "/img/nvgann6j_IMG_6916.webp", alt: "Hyundai i20 2025 zezadu", label: "Zezadu" },
      { url: "/img/j7va5lh2_i20_7.webp", alt: "Hyundai i20 2025 interiér", label: "Interiér" },
      { url: "/img/4cw5r95a_i20_1.webp", alt: "Hyundai i20 2025 automatická převodovka", label: "Převodovka" },
    ],
    featureGroups: [
      {
        title: { cs: "Komfort a interiér", en: "Comfort and interior", de: "Komfort und Innenraum" },
        items: [
          { cs: "Manuální klimatizace", en: "Manual air conditioning", de: "Manuelle Klimaanlage" },
          { cs: "Kůží potažený multifunkční volant a hlavice řadicí páky", en: "Leather-wrapped multifunction steering wheel and gear knob", de: "Lederbezogenes Multifunktionslenkrad und Schaltknauf" },
          { cs: "Výškově nastavitelné sedadlo řidiče", en: "Height-adjustable driver's seat", de: "Höhenverstellbarer Fahrersitz" },
          { cs: "Středová posuvná opěrka rukou vpředu s úložným prostorem", en: "Front sliding center armrest with storage", de: "Verschiebbare vordere Mittelarmlehne mit Staufach" },
        ],
      },
      {
        title: { cs: "Moderní technologie a multimédia", en: "Modern technology and multimedia", de: "Moderne Technik und Multimedia" },
        items: [
          { cs: 'Integrovaná navigace s 10,25" dotykovým displejem', en: 'Integrated navigation with a 10.25" touchscreen', de: 'Integrierte Navigation mit 10,25" Touchscreen' },
          { cs: "Digitální přístrojový panel", en: "Digital instrument cluster", de: "Digitales Kombiinstrument" },
          { cs: "Vzdálená správa vozu Bluelink, kterou lze ovládat přes aplikaci v telefonu", en: "Bluelink remote vehicle management, controllable via the phone app", de: "Bluelink Fernsteuerung des Fahrzeugs, bedienbar über die Smartphone-App" },
          { cs: "Bezdrátové Apple CarPlay a Android Auto", en: "Wireless Apple CarPlay and Android Auto", de: "Kabelloses Apple CarPlay und Android Auto" },
          { cs: "Bluetooth handsfree + USB-C konektory vpředu i vzadu", en: "Bluetooth hands-free + USB-C ports front and rear", de: "Bluetooth-Freisprecheinrichtung + USB-C-Anschlüsse vorne und hinten" },
        ],
      },
      {
        title: { cs: "Bezpečnostní a asistenční systémy", en: "Safety and assistance systems", de: "Sicherheits- und Assistenzsysteme" },
        items: [
          { cs: "Zadní parkovací kamera + zadní parkovací senzory", en: "Rear parking camera + rear parking sensors", de: "Rückfahrkamera + hintere Parksensoren" },
          { cs: "Aktivní asistent pro vedení vozu v jízdních pruzích", en: "Active lane keeping assist", de: "Aktiver Spurhalteassistent" },
          { cs: "Autonomní nouzové brzdění s detekcí aut, chodců a cyklistů", en: "Autonomous emergency braking with car, pedestrian and cyclist detection", de: "Autonomes Notbremssystem mit Fahrzeug-, Fußgänger- und Radfahrererkennung" },
          { cs: "Tempomat s omezovačem rychlosti", en: "Cruise control with speed limiter", de: "Tempomat mit Geschwindigkeitsbegrenzer" },
          { cs: "Upozornění na cestující vzadu", en: "Rear seat occupant alert", de: "Hinweis auf Insassen im Fond" },
        ],
      },
      {
        title: { cs: "Exteriér", en: "Exterior", de: "Exterieur" },
        items: [
          { cs: '16" originální kola z lehké slitiny', en: '16" original alloy wheels', de: '16" Original-Leichtmetallräder' },
          { cs: "LED světla pro denní svícení + LED poziční světla", en: "LED daytime running lights + LED position lights", de: "LED-Tagfahrlicht + LED-Positionsleuchten" },
          { cs: "Zatmavená zadní skla", en: "Tinted rear windows", de: "Abgedunkelte hintere Scheiben" },
          { cs: "Elektricky nastavitelná a vyhřívaná vnější zpětná zrcátka", en: "Electrically adjustable and heated exterior mirrors", de: "Elektrisch verstellbare und beheizbare Außenspiegel" },
        ],
      },
    ],
  },

  {
    slug: "mazda-cx-60-takumi",
    name: "Mazda CX-60 Takumi",
    year: 2025,
    bodyType: { cs: "SUV", en: "SUV", de: "SUV" },
    priceMonthly: 29500,
    fuel: { cs: "Nafta 3.3", en: "Diesel 3.3", de: "Diesel 3.3" },
    transmission: { cs: "Automat", en: "Automatic", de: "Automatik" },
    mileage: { cs: "cca 3 500 km", en: "approx. 3,500 km", de: "ca. 3.500 km" },
    multipleAvailable: true,
    images: [
      { url: "/img/c7gj2k4g_XC_F1.webp", alt: "Mazda CX-60 Takumi zepředu", label: "Zepředu" },
      { url: "/img/mz5199z5_XC_3.webp", alt: "Mazda CX-60 Takumi z boku", label: "Bok" },
      { url: "/img/a4qkpliu_XC_4.webp", alt: "Mazda CX-60 Takumi zezadu", label: "Zezadu" },
      { url: "/img/nimgf7yy_XC_F2.webp", alt: "Mazda CX-60 Takumi interiér", label: "Interiér" },
      { url: "/img/ch6mn2ds_XC4.webp", alt: "Mazda CX-60 Takumi zavazadlový prostor", label: "Kufr" },
    ],
    featureGroups: [
      {
        title: { cs: "Komfort a interiér", en: "Comfort and interior", de: "Komfort und Innenraum" },
        items: [
          { cs: "Automatická klimatizace", en: "Automatic climate control", de: "Klimaautomatik" },
          { cs: "Elektrické výklopné a posuvné střešní okno se sluneční clonou", en: "Electric tilt-and-slide sunroof with sunshade", de: "Elektrisches Schiebe-/Hebedach mit Sonnenschutz" },
          { cs: "Prémiové LED osvětlení interiéru", en: "Premium LED interior lighting", de: "Premium-LED-Innenbeleuchtung" },
          { cs: "Systém DPS (automatické nastavení místa řidiče – pomocí kamery přizpůsobí sedadlo, elektricky nastavitelný volant, HUD a zrcátka na postavu)", en: "DPS system (automatic driver position setup – uses a camera to adjust the seat, electrically adjustable steering wheel, HUD and mirrors to your build)", de: "DPS-System (automatische Einstellung des Fahrerplatzes – passt per Kamera Sitz, elektrisch verstellbares Lenkrad, HUD und Spiegel an die Statur an)" },
          { cs: "Elektrické otevírání a zavírání kufru s funkcí Hands-free", en: "Electric hands-free opening and closing of the boot", de: "Elektrisches Öffnen und Schließen des Kofferraums mit Hands-free-Funktion" },
          { cs: "Bezklíčový přístup Smart Keyless Entry", en: "Smart Keyless Entry access", de: "Schlüsselloser Zugang Smart Keyless Entry" },
        ],
      },
      {
        title: { cs: "Moderní technologie a multimédia", en: "Modern technology and multimedia", de: "Moderne Technik und Multimedia" },
        items: [
          { cs: '12" plně digitální přístrojový panel', en: '12" fully digital instrument cluster', de: '12" voll digitales Kombiinstrument' },
          { cs: '12" centrální displej', en: '12" central display', de: '12" Zentraldisplay' },
          { cs: "Špičkový Head-up displej", en: "Top head-up display", de: "Hochwertiges Head-up-Display" },
          { cs: "Prémiový audiosystém BOSE s 12 reproduktory", en: "Premium BOSE audio system with 12 speakers", de: "Premium-Soundsystem BOSE mit 12 Lautsprechern" },
          { cs: "Bezdrátové Apple CarPlay a Android Auto", en: "Wireless Apple CarPlay and Android Auto", de: "Kabelloses Apple CarPlay und Android Auto" },
          { cs: "Bezdrátové nabíjení telefonu", en: "Wireless phone charging", de: "Kabelloses Laden des Smartphones" },
          { cs: "Integrovaná navigace", en: "Integrated navigation", de: "Integrierte Navigation" },
          { cs: "Volič jízdních režimů My-Drive (Normální, Sport, Off-Road)", en: "My-Drive mode selector (Normal, Sport, Off-Road)", de: "My-Drive Fahrmoduswahl (Normal, Sport, Off-Road)" },
        ],
      },
      {
        title: { cs: "Bezpečnostní a asistenční systémy", en: "Safety and assistance systems", de: "Sicherheits- und Assistenzsysteme" },
        items: [
          { cs: '360° Top View Monitor (včetně digitálního pohledu "skrz vůz")', en: '360° Top View Monitor (including a digital "see-through" view)', de: '360°-Top-View-Monitor (inkl. digitaler "durchsichtiger" Ansicht)' },
          { cs: "Přední a zadní parkovací senzory", en: "Front and rear parking sensors", de: "Parksensoren vorne und hinten" },
          { cs: "Adaptivní tempomat pro celý rozsah rychlostí", en: "Adaptive cruise control for the full speed range", de: "Adaptiver Tempomat für den gesamten Geschwindigkeitsbereich" },
          { cs: "Asistent pro jízdu v silném provozu", en: "Traffic jam assist", de: "Stauassistent" },
          { cs: "Pokročilé hlídání mrtvého úhlu s upozorněním na provoz za vozem", en: "Advanced blind-spot monitoring with rear cross-traffic alert", de: "Erweiterter Totwinkel-Assistent mit Querverkehrswarnung hinten" },
          { cs: "Nouzový brzdový asistent", en: "Emergency brake assist", de: "Notbremsassistent" },
          { cs: "Rozpoznávání dopravních značek", en: "Traffic sign recognition", de: "Verkehrszeichenerkennung" },
          { cs: "Funkce Auto Hold", en: "Auto Hold function", de: "Auto-Hold-Funktion" },
          { cs: "Asistent pro bezpečný rozjezd do kopce", en: "Hill start assist", de: "Berganfahrassistent" },
        ],
      },
      {
        title: { cs: "Exteriér", en: "Exterior", de: "Exterieur" },
        items: [
          { cs: "Špičkové adaptivní LED světlomety s automatickým vyrovnáváním", en: "Top adaptive LED headlights with automatic leveling", de: "Hochwertige adaptive LED-Scheinwerfer mit automatischer Niveauregulierung" },
          { cs: "Dešťový senzor", en: "Rain sensor", de: "Regensensor" },
          { cs: "Tmavá tónovaná zadní skla", en: "Dark tinted rear windows", de: "Dunkel getönte hintere Scheiben" },
          { cs: "Střešní ližiny", en: "Roof rails", de: "Dachreling" },
          { cs: "Designové prvky pro verzi Takumi", en: "Design accents for the Takumi version", de: "Design-Akzente der Takumi-Version" },
        ],
      },
    ],
  },

  {
    slug: "audi-a5-sportback-2013",
    name: "Audi A5 Sportback",
    year: 2013,
    bodyType: { cs: "Sportback", en: "Sportback", de: "Sportback" },
    priceMonthly: 14000,
    fuel: { cs: "Nafta 3.0 TDI V6 (180 kW)", en: "Diesel 3.0 TDI V6 (180 kW)", de: "Diesel 3.0 TDI V6 (180 kW)" },
    transmission: { cs: "Automat 7° S-tronic", en: "7-speed S-tronic automatic", de: "7-Gang S-tronic Automatik" },
    mileage: null,
    multipleAvailable: false,
    description: {
      cs: "Motor 3.0 TDI V6 (180 kW) s trvalým pohonem všech kol Quattro.",
      en: "3.0 TDI V6 engine (180 kW) with permanent Quattro all-wheel drive.",
      de: "3.0 TDI V6 Motor (180 kW) mit permanentem Quattro-Allradantrieb.",
    },
    images: [
      { url: "/img/1fysq4lj_IMG_6917.webp", alt: "Audi A5 Sportback zepředu", label: "Zepředu" },
      { url: "/img/885pauyx_A4.webp", alt: "Audi A5 Sportback přední profil", label: "Přední profil" },
      { url: "/img/9kpq5y7j_IMG_6919.webp", alt: "Audi A5 Sportback zezadu", label: "Zezadu" },
      { url: "/img/edxwrzwv_A1.webp", alt: "Audi A5 Sportback interiér", label: "Interiér" },
    ],
    featureGroups: [
      {
        title: { cs: "Komfort a interiér", en: "Comfort and interior", de: "Komfort und Innenraum" },
        items: [
          { cs: "Automatická klimatizace", en: "Automatic climate control", de: "Klimaautomatik" },
          { cs: "Komfortní kožená sedadla v atraktivním světlém provedení", en: "Comfort leather seats in an attractive light finish", de: "Komfort-Ledersitze in attraktiver heller Ausführung" },
          { cs: "Vyhřívání předních sedadel", en: "Heated front seats", de: "Sitzheizung vorne" },
          { cs: "Multifunkční sportovní volant", en: "Multifunction sports steering wheel", de: "Multifunktions-Sportlenkrad" },
        ],
      },
      {
        title: { cs: "Moderní technologie a multimédia", en: "Modern technology and multimedia", de: "Moderne Technik und Multimedia" },
        items: [
          { cs: "MMI Navigace Plus s barevným displejem a otočným ovladačem na středovém panelu", en: "MMI Navigation Plus with color display and rotary control on the center console", de: "MMI Navigation Plus mit Farbdisplay und Dreh-/Drücksteller auf der Mittelkonsole" },
          { cs: "Barevný informační displej řidiče", en: "Color driver information display", de: "Farbiges Fahrerinformationsdisplay" },
          { cs: "Audi sound system", en: "Audi sound system", de: "Audi Sound System" },
          { cs: "Bluetooth pro telefonování a streamování hudby", en: "Bluetooth for calls and music streaming", de: "Bluetooth zum Telefonieren und Musik-Streaming" },
        ],
      },
      {
        title: { cs: "Bezpečnost", en: "Safety", de: "Sicherheit" },
        items: [
          { cs: "Parkovací systém Audi Parking System (přední + zadní senzory)", en: "Audi Parking System (front + rear sensors)", de: "Audi Parking System (Sensoren vorne + hinten)" },
          { cs: "Tempomat", en: "Cruise control", de: "Tempomat" },
          { cs: "Pohon všech kol Quattro", en: "Quattro all-wheel drive", de: "Quattro-Allradantrieb" },
        ],
      },
      {
        title: { cs: "Exteriér", en: "Exterior", de: "Exterieur" },
        items: [
          { cs: "Bi-xenonové světlomety s LED denním svícením + LED zadní světla", en: "Bi-xenon headlights with LED daytime running lights + LED tail lights", de: "Bi-Xenon-Scheinwerfer mit LED-Tagfahrlicht + LED-Rückleuchten" },
          { cs: '18" litá kola', en: '18" alloy wheels', de: '18" Leichtmetallräder' },
          { cs: "Tónovaná zadní skla", en: "Tinted rear windows", de: "Getönte hintere Scheiben" },
          { cs: "Chromové prvky", en: "Chrome accents", de: "Chrom-Akzente" },
        ],
      },
    ],
  },
];

export const getVehicleBySlug = (slug) => VEHICLES.find((v) => v.slug === slug);

// Returns the localized string for a { cs, en, de } field (or the value if plain).
export const localize = (val, lang) => {
  if (val == null) return val;
  if (typeof val === "object" && !Array.isArray(val)) return val[lang] ?? val.cs ?? "";
  return val;
};

export const formatPriceMonthly = (price, t) =>
  price == null
    ? t("price.onRequest")
    : `${t("price.from")} ${Number(price).toLocaleString("cs-CZ")} Kč ${t("price.perMonth")}`;

// Append resize variant for CMS-served images (thumb | card | web); static /img files map to pre-generated thumbs.
export const imgV = (url, v) => {
  if (!url) return url;
  if (url.startsWith("/api/vehicles/image/")) return `${url}?v=${v}`;
  if (v === "thumb" && url.startsWith("/img/") && !url.startsWith("/img/thumb/")) {
    return url.replace("/img/", "/img/thumb/");
  }
  return url;
};

export const hasPromo = (vehicle) =>
  vehicle?.priceMonthly != null && vehicle?.priceOriginal > vehicle?.priceMonthly;

// Rental length options and the discount applied to the monthly price (shared by cards, detail and calculator).
export const TERMS = [1, 6, 12, 24];
export const termDiscount = (months) => (months >= 12 ? 0.05 : months >= 6 ? 0.02 : 0);
export const termPrice = (price, months) => (price == null ? null : Math.round(price * (1 - termDiscount(months))));
export const VAT_RATE = 0.21;
// Ceny u aut se zadávají VČETNĚ DPH (hlavní cena). Tohle dopočítá cenu BEZ DPH (menší, sekundární).
export const priceExVat = (gross) => (gross == null ? null : Math.round(gross / (1 + VAT_RATE)));
// Vrátí hlavní a vedlejší cenu podle zvoleného režimu ("incl" = hlavní s DPH, "excl" = hlavní bez DPH).
export const vatPrice = (gross, mode) => {
  if (gross == null) return null;
  const incl = Math.round(gross), excl = Math.round(gross / (1 + VAT_RATE));
  return mode === "excl"
    ? { main: excl, mainLabel: "bez DPH", sub: incl, subLabel: "s DPH" }
    : { main: incl, mainLabel: "s DPH", sub: excl, subLabel: "bez DPH" };
};
export const fmtKc = (n) => Number(n).toLocaleString("cs-CZ");
